// @ts-nocheck
import * as Types from '../../../../__generated__/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ComparePackageOptions_LoadQueryVariables = Types.Exact<{
  checkoutConfigId: Types.Scalars['ID'];
  rpogId: Types.Scalars['ID'];
}>;


export type ComparePackageOptions_LoadQuery = { __typename?: 'Query', checkoutConfig: { __typename?: 'CheckoutConfig', id: string, optionGroups: Array<{ __typename?: 'CheckoutConfigOptionGroup', id: string, options: Array<{ __typename?: 'CheckoutConfigPotentialOption', id: string, totalPriceInCents: number, option: { __typename?: 'ReadyPlanOption', id: string, name: string }, packageOptionMaterials: Array<{ __typename?: 'MaterialVariant', id: string, displayName: string, modelNumber?: string | null | undefined, listing: { __typename?: 'MaterialListing', id: string, description?: string | null | undefined, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined }, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, thumbnail155?: string | null | undefined } | null | undefined } | null | undefined }> }> }> } };

export type ComparePackageOptions_CheckoutConfigOptionFragment = { __typename?: 'CheckoutConfigPotentialOption', id: string, totalPriceInCents: number, option: { __typename?: 'ReadyPlanOption', id: string, name: string }, packageOptionMaterials: Array<{ __typename?: 'MaterialVariant', id: string, displayName: string, modelNumber?: string | null | undefined, listing: { __typename?: 'MaterialListing', id: string, description?: string | null | undefined, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined }, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, thumbnail155?: string | null | undefined } | null | undefined } | null | undefined }> };

export type ComparePackageOptions_MaterialVariantFragment = { __typename?: 'MaterialVariant', id: string, displayName: string, modelNumber?: string | null | undefined, listing: { __typename?: 'MaterialListing', id: string, description?: string | null | undefined, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined }, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, thumbnail155?: string | null | undefined } | null | undefined } | null | undefined };

export const ComparePackageOptions_MaterialVariantFragmentDoc = gql`
    fragment ComparePackageOptions_MaterialVariant on MaterialVariant {
  id
  displayName
  modelNumber
  listing {
    id
    description
    brand {
      id
      name
    }
  }
  featuredImage {
    id
    asset {
      id
      thumbnail155: previewUrl(resizing: {region: FULL, width: 155})
    }
  }
}
    `;
export const ComparePackageOptions_CheckoutConfigOptionFragmentDoc = gql`
    fragment ComparePackageOptions_CheckoutConfigOption on CheckoutConfigPotentialOption {
  id
  totalPriceInCents
  option {
    id
    name
  }
  packageOptionMaterials {
    ...ComparePackageOptions_MaterialVariant
  }
}
    ${ComparePackageOptions_MaterialVariantFragmentDoc}`;
export const ComparePackageOptions_LoadDocument = gql`
    query ComparePackageOptions_Load($checkoutConfigId: ID!, $rpogId: ID!) {
  checkoutConfig(id: $checkoutConfigId) {
    id
    optionGroups(filter: {rpogIds: [$rpogId]}) {
      id
      options {
        ...ComparePackageOptions_CheckoutConfigOption
      }
    }
  }
}
    ${ComparePackageOptions_CheckoutConfigOptionFragmentDoc}`;

/**
 * __useComparePackageOptions_LoadQuery__
 *
 * To run a query within a React component, call `useComparePackageOptions_LoadQuery` and pass it any options that fit your needs.
 * When your component renders, `useComparePackageOptions_LoadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComparePackageOptions_LoadQuery({
 *   variables: {
 *      checkoutConfigId: // value for 'checkoutConfigId'
 *      rpogId: // value for 'rpogId'
 *   },
 * });
 */
export function useComparePackageOptions_LoadQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ComparePackageOptions_LoadQuery, ComparePackageOptions_LoadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ComparePackageOptions_LoadQuery, ComparePackageOptions_LoadQueryVariables>(ComparePackageOptions_LoadDocument, options);
      }
export function useComparePackageOptions_LoadLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ComparePackageOptions_LoadQuery, ComparePackageOptions_LoadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ComparePackageOptions_LoadQuery, ComparePackageOptions_LoadQueryVariables>(ComparePackageOptions_LoadDocument, options);
        }
export type ComparePackageOptions_LoadQueryHookResult = ReturnType<typeof useComparePackageOptions_LoadQuery>;
export type ComparePackageOptions_LoadLazyQueryHookResult = ReturnType<typeof useComparePackageOptions_LoadLazyQuery>;
export type ComparePackageOptions_LoadQueryResult = Apollo.QueryResult<ComparePackageOptions_LoadQuery, ComparePackageOptions_LoadQueryVariables>;